"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import { BLOG_CATEGORIES } from "@/lib/blogTaxonomy";

export default function CategoryChips() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const active = searchParams.get("category");

  function hrefFor(value: string | null): string {
    const params = new URLSearchParams(searchParams.toString());
    if (value === null) {
      params.delete("category");
    } else {
      params.set("category", value);
    }
    const qs = params.toString();
    return qs ? `${pathname}?${qs}` : pathname;
  }

  const baseClass =
    "inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium transition-colors border";

  return (
    <nav
      aria-label="Filter by category"
      className="flex flex-wrap items-center gap-2"
    >
      <Link
        href={hrefFor(null)}
        className={
          active === null
            ? `${baseClass} bg-[#002e65] text-white border-[#002e65]`
            : `${baseClass} bg-white text-[#002e65] border-[#002e65]/20 hover:border-[#002e65]/50`
        }
      >
        All stories
      </Link>
      {BLOG_CATEGORIES.map((c) => {
        const isActive = active === c.value;
        return (
          <Link
            key={c.value}
            href={hrefFor(c.value)}
            className={
              isActive
                ? `${baseClass} bg-[#002e65] text-white border-[#002e65]`
                : `${baseClass} bg-white text-[#002e65] border-[#002e65]/20 hover:border-[#002e65]/50`
            }
          >
            {c.label}
          </Link>
        );
      })}
    </nav>
  );
}
